module.exports = __webpack_public_path__ + "static/media/laptop.996a9f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/laptop.png
// module id = 779
// module chunks = 20